import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../Styles/Blog.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faCalendarDay,
  faCalendar,
  faMessage,
} from "@fortawesome/free-solid-svg-icons";
import "../assets/css/custom-animation.css";
import "../assets/css/animate.min.css";
import { animateScroll as scroll } from "react-scroll";
// import authLogo from "../assets/logo/favIcon.png";
// import img1 from "../assets/All Images/hire-destintion.jpg";
// import img2 from "../assets/All Images/hire-challenges.jpg";
// import img3 from "../assets/All Images/hire-strategies.jpg";
import axios from "axios";
import moment from "moment/moment";
import BlogForm from "./BlogForm";

const Blog = () => {
  const toggleContact = () => {
    scroll.scrollToTop(0, 0);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [posts, setPosts] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("https://mars.zithas.com/api/blog")
      .then((res) => {
        setPosts(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
<div>
  <section className="bd-blog-area pt-40 pb-80 blogOne">
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <div className="bd-section-title-wrapper mb-50">
            {/* <h5 className="bd-section-subtitle mb-15">Innovative Blog</h5> */}
            <h2 className="bd-section-title mb-25" style={{fontSize:"38px"}}>Contact Us</h2>
            <p style={{fontSize:"16px"}}>
              Are you interested in knowing more about Ambrella's Consulting
              or IT Application services?
            </p>
            <p style={{fontSize:"16px"}}>
              Are you interested in partnering with Ambrella to find new
              business and markets for your services or products?
            </p>
            <p style={{fontSize:"16px"}}>
              Fill out some info and we will be in touch shortly. We can't
              wait to hear from you!
            </p>
          </div>
        </div>
        {/* <div className="col-md-6">
  <BlogForm />
</div> */}
        <div className="col-md-6">
          <div className="bd-section-title-wrapper mb-50">
            <form>
              <div className="row contact-reponsive">
                <div className="col-md-6">
                  <div className="bd-contact-field mb-30">
                    <input
                      type="text"
                      placeholder="First Name"
                      className="contact-form form-reponsive"
                      style={{ border: "1px solid black" }}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="bd-contact-field mb-30">
                    <input
                      type="text"
                      className="form-reponsive"
                      placeholder="Last Name"
                      style={{ border: "1px solid black" }}
                      required
                    />
                  </div>
                </div>
                <div className="col-6 email-form-responsive">
                  <div className="bd-contact-field mb-30">
                    <input
                      type="email"
                      className="form-reponsive"
                      placeholder="Email"
                      style={{ border: "1px solid black" }}
                      required
                    />
                  </div>
                </div>

                <div className="col-6 email-form-responsive">
                  <div className="bd-contact-field mb-30">
                    <input
                      type="text"
                      className="form-reponsive"
                      placeholder="Phone no"
                      style={{ border: "1px solid black" }}
                      required
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="bd-contact-field mb-30">
                    <textarea
                      placeholder="Share your Message"
                      style={{ height: "220px", width: "100%", border: "1px solid black" }}
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-12">
                  <div className="bd-contact-field">
                    <button type="submit" className="theme-btn">
                      Submit Enquiry
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Commented code unchanged */}
    </div>
  </section>
</div>

  );
};

export default Blog;
